<template>
  <LoaderWrapper ref="dashboardLoader" class="h-100 p-2 pt-3">

    <div v-if="isTrader && !user.pcId || isTraderOperator" class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">

        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body mt-0">
              <div>
                <span class="m-0 text-capitalize-first"><strong>{{ helper.trans("dashboard.trade_reward") }}</strong></span>
              </div>

              <div class="mt-2" v-for="(rewardSettings, direction) in {'in':payInRewardFee, 'out': payOutRewardFee}">
                <span class="d-block text-capitalize-first">{{ helper.trans(`direction.${direction}`) }}</span>
                <div class="d-flex gap-3" style="flex-wrap: wrap;column-gap: 1rem !important;row-gap: 0.2rem !important;">
                  <div class="m-0 text-capitalize-first" v-for="settings in rewardSettings" :key="settings.name">
                    <div>
                      <span>{{ settings.name }}:</span>
                      <strong class="ms-1">
                        {{ numberFormatter.formatNumber(parseFloat(settings.reward), 1) }}%
                        <span :class="parseFloat(settings.additional) > 0 ? 'text-success' : ''" v-if="settings.additional">{{ parseFloat(settings.additional) > 0 ? '+' : '' }}{{numberFormatter.formatNumber(parseFloat(settings.additional), 1) }}%</span>
                      </strong>
                    </div>
                    <div v-if="settings.traderFeeByDealAmount && settings.traderFeeByDealAmount.length > 0" class="mt-1">
                      <small class="text-muted">{{ helper.trans('labels.fee_ranges') }}:</small>
                <div class="small">
                  <span v-for="(range, index) in settings.traderFeeByDealAmount" :key="index" class="me-2">
                    <span v-if="range.minSum && range.maxSum">
                      {{ numberFormatter.formatNumber(parseFloat(range.minSum.toString()) / 100, 2) }} - {{ numberFormatter.formatNumber(parseFloat(range.maxSum.toString()) / 100, 2) }} {{ range.currency }}: {{ numberFormatter.formatNumber(parseFloat(range.fee), 1) }}%
                    </span>
                    <span v-else-if="range.minSum">
                      ≥{{ numberFormatter.formatNumber(parseFloat(range.minSum.toString()) / 100, 2) }} {{ range.currency }}: {{ numberFormatter.formatNumber(parseFloat(range.fee), 1) }}%
                    </span>
                    <span v-else-if="range.maxSum">
                      ≤{{ numberFormatter.formatNumber(parseFloat(range.maxSum.toString()) / 100, 2) }} {{ range.currency }}: {{ numberFormatter.formatNumber(parseFloat(range.fee), 1) }}%
                    </span>
                  </span>
                </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="currencyRatesByGroups.length > 0" class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">

        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body mt-0">
              <div>
                <span class="m-0 text-capitalize-first"><strong>{{ helper.trans("labels.currency_rates") }}</strong></span>
              </div>

              <div class="mt-2" v-for="(currencyRates, direction) in {'in':currencyRatesByGroups.filter(item =>item.direction === 'in'), 'out': currencyRatesByGroups.filter(item =>item.direction === 'out')}">
                <span class="d-block text-capitalize-first">{{ helper.trans(`direction.${direction}`) }}</span>
                <div class="d-flex gap-3" style="flex-wrap: wrap;column-gap: 1rem !important;row-gap: 0.2rem !important;">
                  <span class="m-0 text-capitalize-first" v-for="settings in currencyRates">
                  <span class="me-1">{{ settings.name }}:</span>
                  <strong class="me-2" v-for="(item, index) in settings.currencyRates" :key="index">
                    {{ numberFormatter.formatMoney(item.rate) }}
                  </strong>
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="accounts" class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">
        <div class="row">
          <div class="col-sm-12">
            <div class="d-flex justify-content-center align-items-center flex-wrap" style="column-gap: 1em">
              <div v-for="account in accounts" :key="account.currency" class="card card-body mt-0 w-100">
                <div class="d-flex justify-content-between gap-3 flex-wrap">
                  <AccountWidget :show-icon="true" :account="account"></AccountWidget>
                  <div class="d-flex gap-2 align-items-center pe-1 ps-1">
                    <router-link
                      class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                      :active-class="''"
                      :exact-active-class="''"
                      :to="{name: 'accountOperations', query: {currency: account.currency}}"
                    >
                      <i class="fa fa-list"></i> {{ helper.trans("button.history") }}
                    </router-link>
                    <button v-if="isTrader || isTeamLead || isReferral" type="button" @click.prevent="withdrawAccount = account" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa-solid fa-upload"></i> {{ helper.trans("button.withdraw") }}</button>
                    <button v-if="isTrader || isTraderOperator || isTeamLead || isReferral" @click.prevent="accountWalletModal?.show(account)" type="button" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa-solid fa-download"></i> {{ helper.trans("button.deposit") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="(isTrader || isTraderOperator) && (usdtRate || bankAppsLink || manualLink)">
          <div class="card card-body mt-0 col-sm-12">
            <div class="row">
              <div class="col-sm-12 col-md-4 d-flex justify-content-center align-items-center  pt-2 pb-2" v-if="usdtRate">
                <img :src="require(`@/assets/img/currencies/USDT.svg`)" style="height: 1.25rem">
                <img :src="require(`@/assets/img/currencies/RUB.svg`)" style="height: 1.25rem; margin-left: -7px;" class="me-1">
                <strong>{{numberFormatter.formatMoney(usdtRate)}}</strong>
              </div>
              <div class="col-sm-12 col-md-4 d-flex justify-content-center align-items-center  pt-2 pb-2" v-if="bankAppsLink">
                <i class="fa fa-mobile-screen-button me-2"></i>
                <a :href="bankAppsLink" class="float-end" target="_blank">{{ helper.trans('labels.bank_apps_link')}}</a>
              </div>
              <div class="col-sm-12 col-md-4 d-flex justify-content-center align-items-center  pt-2 pb-2" v-if="manualLink">
                <i class="fa fa-external-link me-2"></i>
                <a :href="manualLink" class="float-end" target="_blank">{{ helper.trans('labels.manual_link')}}</a>
              </div>
            </div>

          </div>
        </div>

        <div class="row" v-if="(isTrader || isTraderOperator) && onlineAmountsStats.options && onlineAmountsStats.options?.length > 0">
          <div class="card card-body mt-0 col-sm-12">
            <table class="table align-middle text-left text-nowrap position-relative">
              <thead>
              <tr class="">
                <th class="text-capitalize" style="width: 0">Сумма</th>
                <th :style="{'width': (100 / onlineAmountsStats.options.length) + '%'}" v-for="option in onlineAmountsStats.options" :key="option" class="text-capitalize">
                  <span v-if="option">{{ helper.trans(`payment_options.${option}`)}}</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(stat, index) in onlineAmountsStats.stat" :key="index">
                <td class="text-end">{{numberFormatter.formatNumber(stat.min)}} - {{numberFormatter.formatNumber(stat.max)}}</td>
                <td v-for="option in onlineAmountsStats.options" :key="option">

                  <b-progress max="100" class="position-relative stat-progress-bar">
                    <b-progress-bar :value="parseInt(stat.stats[option]?.percent)" :style="{background: getProgressBackground(stat.stats[option]?.percent)}" class=""></b-progress-bar>
                    <small class="justify-content-center d-flex position-absolute w-100"></small>
                  </b-progress>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>

      </div>
    </div>

    <div v-if="isReferral && store.getters.getAppData?.REFERRAL_MERCHANT_FEES_ENABLED" class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body mt-0">
              <div>
                <span class="m-0 text-capitalize-first"><strong>{{ helper.trans("dashboard.referral_merchant_fees") }}</strong></span>
              </div>
              <div class="mt-2">
                <ReferralMerchantFeesTable></ReferralMerchantFeesTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isMerchant || isMerchantOperator" id="stores" class="row">
      <div class="col-sm-12">
        <h5 class="ms-3 me-3 mb-0 text-center mt-2">{{ helper.trans("labels.stores") }}:</h5>
      </div>

      <MerchantStoresList :stores="stores" :merchant="user" @updated="loadStores()"></MerchantStoresList>
    </div>

    <div>

      <b-modal :title="helper.trans('labels.withdrawal')" :modelValue="withdrawAccount !== null" header-class="text-capitalize" body-class="pt-0" footer-class="d-flex justify-content-between" @update:modelValue="$event === false && (withdrawAccount = null)">
        <template #default>
          <WithdrawalForm ref="withdrawalForm" :account="withdrawAccount"></WithdrawalForm>
        </template>
        <template #footer>
          <button type="button" v-on:click="withdrawAccount = null" class="btn btn-outline-dark btn-sm text-capitalize-first">{{ helper.trans("button.cancel") }}</button>
          <LoaderWrapper ref="loaderWithdrawalForm" :zoom="0.5">
            <button type="button" v-on:click="createWithdraw()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans("button.withdraw") }}</button>
          </LoaderWrapper>
        </template>
      </b-modal>

      <AccountWalletModal ref="accountWalletModal"></AccountWalletModal>
      <ConfirmModal ref="confirmModal"></ConfirmModal>
    </div>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, onUnmounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import AccountDTO from "@/models/AccountDTO";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import WithdrawalForm from "@/components/Form/WithdrawalForm.vue";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import ConfirmModal from "@/components/ConfirmModal.vue";
import AccountWalletModal from "@/components/AccountWalletModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import MerchantStoresList from "@/components/MerchantStoresList.vue";
import ReferralMerchantFeesTable from "@/components/ReferralMerchantFeesTable.vue";
import AccountWidget from "@/components/AccountWidget.vue";
import TraderRewardSettingsDTO from "@/models/TraderRewardSettingsDTO";
import {Direction} from "@/models/enum/Direction";
import MoneyDTO from "@/models/MoneyDTO";

const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  name: 'Dashboard',
  components: {
    AccountWidget,
    LoaderWrapper,
    WithdrawalForm,
    AccountWalletModal,
    ConfirmModal,
    CopyButton,
    MerchantStoresList,
    ReferralMerchantFeesTable
  },
  setup() {
    const store = useStore()
    const dashboardLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const accountWalletModal = ref<InstanceType<typeof AccountWalletModal> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)
    const withdrawalForm = ref<InstanceType<typeof WithdrawalForm> | null>(null)
    const loaderWithdrawalForm = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const stores = computed<MerchantStoreDTO[]>(() => store.getters['merchantStores/list'])

    const state = reactive({
      depositAccount: null as AccountDTO|null,
      withdrawAccount: null as AccountDTO|null,
      accounts: [] as AccountDTO[],
      merchantStoreModal: false,
      merchantStoreModalTitle: "",
      statsTab: 'today',
      rewardSettings: [] as TraderRewardSettingsDTO[],
      currencyRatesByGroups: [] as any[],
      bankAppsLink: '' as string,
      manualLink: '' as string,
      onlineAmountsStats: [] as any,
      updateRateInterval: null as any,
      usdtRate: null as MoneyDTO|null
    });

    const createWithdraw = async () => {
      loaderWithdrawalForm.value?.show()
      withdrawalForm.value?.save().then(() => {
        state.withdrawAccount = null;
        loaderWithdrawalForm.value?.hide()
        loadAccounts()
      }).catch(() => {
        loaderWithdrawalForm.value?.hide()
      })
    }

    const loadAccounts = async () => {
      dashboardLoader.value?.show()
      state.accounts = await api.accountsAll()
      dashboardLoader.value?.hide()
    }

    const loadCurrencyRatesSettings = async () => {
      state.currencyRatesByGroups = await api.traderCurrencyRatesByGroupsSettings()
    }

    const loadRewardSettings = async () => {
      state.rewardSettings = await api.traderRewardSettings()
    }

    const loadStores = async () => {
      dashboardLoader.value?.show()
      await store.dispatch('merchantStores/loadList');
      let accountsByCurrency = {} as any
      for (const merchantStore of stores.value as MerchantStoreDTO[]) {
        for (const storeAccount of merchantStore.accounts) {
          const account = storeAccount.account
          if (!accountsByCurrency.hasOwnProperty(account.currency)) {
            accountsByCurrency[account.currency] = {
              currency: account.currency,
              sum: {...account.sum},
              frozenSum: {...account.frozenSum},
              correctionSum: {...(account.correctionSum ?? {amount: '0', currency: account.currency})},
              insuranceLimitSum: {...account.insuranceLimitSum},
              insuranceSum: {...account.insuranceSum},
              insuranceLimitReach: account.insuranceLimitReach,
              sumWithoutInsurance: {...account.sumWithoutInsurance},
            } as AccountDTO
          } else {
            accountsByCurrency[account.currency].sum.amount = (parseFloat(account.sum.amount) + parseFloat(accountsByCurrency[account.currency].sum.amount)).toString()
            accountsByCurrency[account.currency].frozenSum.amount = (parseFloat(account.frozenSum.amount) + parseFloat(accountsByCurrency[account.currency].frozenSum.amount)).toString()
            accountsByCurrency[account.currency].correctionSum.amount = (parseFloat((account.correctionSum?.amount ?? '0')) + parseFloat(accountsByCurrency[account.currency].correctionSum.amount)).toString()
            accountsByCurrency[account.currency].insuranceSum.amount = (parseFloat(account.insuranceSum.amount) + parseFloat(accountsByCurrency[account.currency].insuranceSum.amount)).toString()
            accountsByCurrency[account.currency].insuranceLimitSum.amount = (parseFloat(account.insuranceLimitSum.amount) + parseFloat(accountsByCurrency[account.currency].insuranceLimitSum.amount)).toString()
            accountsByCurrency[account.currency].sumWithoutInsurance.amount = (parseFloat(account.sumWithoutInsurance.amount) + parseFloat(accountsByCurrency[account.currency].sumWithoutInsurance.amount)).toString()
          }
        }
      }

      state.accounts = Object.values(accountsByCurrency);

      dashboardLoader.value?.hide()
    }

    const isTrader = computed<boolean>(() => store.getters.isTrader);
    const isTraderOperator = computed<boolean>(() => store.getters.isTraderOperator);
    const isMerchant = computed<boolean>(() => store.getters.isMerchant);
    const isMerchantOperator = computed<boolean>(() => store.getters.isMerchantOperator);
    const isTeamLead = computed<boolean>(() => store.getters.isTeamLead);
    const isReferral = computed<boolean>(() => store.getters.isReferral);

    const updateRates = async () => {
      const rates =  await api.currencyRates();
      state.usdtRate = rates.length > 0 ? (rates[0].rate as unknown as MoneyDTO) : null;

    }

    onUnmounted(() => {
      if (state.updateRateInterval) {
        clearInterval(state.updateRateInterval)
        state.updateRateInterval = null
      }
    })

    onMounted(async () => {
      if (isTrader.value || isTraderOperator.value) {
        loadAccounts();
        loadRewardSettings();
        loadCurrencyRatesSettings();
        api.bankAppsLink().then(resp => state.bankAppsLink = resp);
        api.manualLink().then(resp => state.manualLink = resp);
        api.statisticOnlineAmounts().then(resp => state.onlineAmountsStats = resp);

        updateRates();
        state.updateRateInterval = setInterval(updateRates, 15000)

      } else if (isTeamLead.value || isReferral.value) {
        loadAccounts();
      } else if (isMerchant.value || isMerchantOperator.value) {
        loadStores();
        store.dispatch('merchantStores/setCurrentStore', null)
      }
    });

    const getProgressBackground = (percent:number) => {
      if (percent <= 20) {
        return 'linear-gradient(to right, green, limegreen)';
      } else if (percent <= 50) {
        return 'linear-gradient(to right, orange, orangered)';
      } else {
        return 'linear-gradient(to right, red, darkred)';
      }
    }

    const payInRewardFee = computed<TraderRewardSettingsDTO[]>(() => {
      if (!isTrader) {
        return [];
      }

      return state.rewardSettings.filter((item) => item.direction === Direction.PAY_IN)
    })

    const payOutRewardFee = computed<TraderRewardSettingsDTO[]>(() => {
      if (!isTrader) {
        return [];
      }

      return state.rewardSettings.filter((item) => item.direction === Direction.PAY_OUT)
    })

    return {
      ...toRefs(state),
      store,
      stores,
      isTrader,
      isTraderOperator,
      isMerchant,
      isTeamLead,
      isMerchantOperator,
      isReferral,
      user: computed(() => store.getters.getUser),
      dashboardLoader,
      dateHelper,
      numberFormatter,
      helper,
      loaderCreateFrom,
      accountWalletModal,
      confirmModal,
      createWithdraw,
      loadStores,
      loaderWithdrawalForm,
      withdrawalForm,
      payInRewardFee,
      payOutRewardFee,
      getProgressBackground
    }
  }
})
</script>
